import PlaybackAwareCta, { PlaybackAwareCtaProps } from './PlaybackAwareCta';

export default PlaybackAwareCta;
export type { PlaybackAwareCtaProps };
